import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {Box} from '@mui/material';
import CustomPagination from '../../../components/customPagination';
import { useGetBusinessProfilesHandler } from '../dataHandlers/getBusinessProfilesHandler';
import BusinessProfileActions from "../../common/BusinessProfileActions";
import BusinessProfileTableStatusChip from "./BusinessProfilesTableStatusChip";

const BusinessProfilesTable = ({ handlePaginationChange, searchQuery = {} }) => {
  const { businessProfiles, totalDocuments, isLoading } = useGetBusinessProfilesHandler({ searchQuery });

  const columns = [
    {
      headerName: 'Status',
      field: 'status',
      flex: 0.5,
      renderCell: (params) => {
        return <BusinessProfileTableStatusChip status={params.row.status} />;
      },
    },
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
      valueGetter: (params) => {
        return params;
      },
    },
    {
      field: 'contact',
      headerName: 'Contact Info',
      flex: 1,
      renderCell: (params) => {
        const contacts = [];
        if (params.row.email) contacts.push(params.row.email);
        if (params.row.telephone) contacts.push(params.row.telephone);
        return contacts.join(' / ') || 'N/A';
      },
    },
    {
      field: 'company_id',
      headerName: 'Peppol Identifier',
      flex: 1,
      renderCell: (params) => {
        return params.row.endpoint_scheme_id + ':' + params.row.endpoint_id;
      }
    },
    {
      field: 'address',
      headerName: 'Country',
      flex: 1,
      renderCell: (params) => {
        const address = params.row.postal_address;
        if (!address) return 'N/A';
        return `${address.country}`;
      },
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        return (
            <Box
                sx={{
                  display: 'flex',
                  width: '100%',
                  gap: 0.6,
                }}
            >
              <BusinessProfileActions
                  profile={params.row}
                  documentApiBaseKey={'business-profiles'}
              />
            </Box>
        );
      },
    },
  ];

  return (
    <Box>
      <DataGrid
        rows={businessProfiles}
        columns={columns}
        getRowId={(row) => row.id}
        paginationMode="server"
        rowCount={totalDocuments}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10, 25]}
        disableRowSelectionOnClick
        onPaginationModelChange={(model) => {
          handlePaginationChange(model.page, model.pageSize);
        }}
        slots={{
          pagination: CustomPagination,
        }}
      />
    </Box>
  );
};

export default BusinessProfilesTable;
